import { PureComponent } from 'react'
import styled from 'glamorous'
import { withConsumer } from 'store'
import { noop } from 'lodash'
import { $, getError } from 'utils'
import { Icon } from 'components'
import { PERSON, DESCRIPTOR, LIST } from 'queries'
import { client } from 'config'


const InputContainer = styled.div({
  position: 'relative',
  width: '100%',
  height: '34px',
  backgroundColor: 'white',
  borderRadius: 3,
  border: 'var(--border)',
})

const Input = styled.input({
  display: 'inline-block',
  position: 'absolute',
  height: '100%',
  width: 'calc(100% - 40px)',
  left: 0,
  top: 0,
  textAlign: 'left',
  border: 'none',
  boxShadow: 'none',
  fontSize: 14,
  padding: 0,
  paddingLeft: 15,
  '&': {
    outline: 'none !important',
    boxShadow: 'none !important'
  }
})

const IconContainer = styled.span({
  position: 'absolute',
  right: 10,
  height: '100%',
  display: 'flex',
  alignItems: 'center'
})

class PanelSearchInput extends PureComponent {

  static defaultProps = {
    onChange: noop,
  }

  state = {
    value: ''
  }

  handleChange = (e) => {
    const { targetType, onChange } = this.props
    const value = e.target.value
    this.setState({ value })

    if (value.length === 0) { return }

    client.query({
      query: targetType === 'person' ? PERSON : targetType === 'descriptor' ? DESCRIPTOR : LIST,
      fetchPolicy: 'network-only',
      variables: { uuid: value }
    }).then(({ data }) => {
        if (data && data[targetType]) {
          onChange(data[targetType])
        }
      }
    ).catch(error => this.props.setErrorMessage(getError(error)))
  }

  render() {
    const {value} = this.state

    return (
      $(InputContainer,
        $(Input, {
          value,
          type: 'text',
          placeholder: 'Search by id',
          onChange: this.handleChange,
        }),
        $(IconContainer, $(Icon, { type: 'search', size: 24, isHoverable: false })),
      )
    )
  }
}

export default withConsumer(PanelSearchInput)



// WEBPACK FOOTER //
// ./src/components/panels/PanelSearchInput.js